import { Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import { LegendProps } from 'recharts';

const useStyle = makeStyles(() =>
  createStyles({
    legendTitle: {
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '20px',
      marginLeft: '8px',
    },
  }),
);

const CustomLegend = ({ payload }: LegendProps): JSX.Element => {
  const classes = useStyle();
  if (!payload) {
    return <></>;
  }
  return (
    <Box display="flex" style={{ marginBottom: '17px', marginLeft: '28px' }}>
      {payload.map((entry) => (
        <Box
          display="flex"
          style={{ marginRight: '15px' }}
          alignItems="center"
          key={`item-${entry.value}`}
        >
          <svg
            viewBox="0 0 100 100"
            width="15.37px"
            height="15.37px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50"
              cy="50"
              r="50"
              fill={entry.color}
              aria-label="1 legend circle"
            />
          </svg>
          <Typography className={classes.legendTitle}>{entry.value}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CustomLegend;
